import React from 'react';
import { NavLink } from 'react-router-dom';
import carouselImg from '../carouselImage.json'

const { src } = carouselImg

function Carousel(props) {
    return(
        <>
            <div id="carousel" className="carousel slide" data-ride="carousel">
            <div className="shade" ></div>
            <div className="overlay">
                    <div className="banner-text">
                        <p className="text text-white">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident ducimus quidem ipsa excepturi? Pariatur 
                        </p>

                        <NavLink to="/signup" className="cta btn btn-md btn-primary text-white">
                            Get Started
                        </NavLink>
                    </div>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={src[0].url} alt="slides" className="d-block w-100" />
                    </div>
                </div>
               
            </div>


        </>
    );
}

export default Carousel;